// components/orders/ReciboWhatsApp.js — comprobante-whatsapp (19-oct-2026; fix-recibo-wa 20-oct).
// En el DETALLE del pedido: el bloque SIEMPRE está (antes desaparecía sin billing.phone — caso
// #11759: POS sin teléfono en el pedido, cliente CON celular en su ficha). Quién decide si hay a
// qué celular enviar es el BACKEND (`wa_disponible` de GET /recibo-envios, resuelto con la
// definición única: teléfono del pedido ‖ ficha del cliente ‖ correo sintético @pos.local); sin
// celular el botón no se ofrece y se dice por qué: «Sin celular: no se puede enviar». El wa.me y
// el mensaje los arma el backend (POST /api/orders/:id/recibo-whatsapp), que además registra el envío.
import React, { useEffect, useState } from 'react';
import Button from '../ui/Button';
import { fmtFechaCorta } from '../../utils/colTimeUtils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const jsonH = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

export default function ReciboWhatsApp({ order }) {
  const [envios, setEnvios] = useState([]);
  const [waDisponible, setWaDisponible] = useState(null); // null = aún sin respuesta del backend
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState(null);
  const orderId = order?.id;

  useEffect(() => {
    if (!orderId) return;
    setEnvios([]); setError(null); setWaDisponible(null);
    fetch(`${API_URL}/api/orders/${orderId}/recibo-envios`, { headers: jsonH() })
      .then((r) => (r.ok ? r.json() : { envios: [] }))
      .then((d) => { setEnvios(d.envios || []); setWaDisponible(typeof d.wa_disponible === 'boolean' ? d.wa_disponible : null); })
      .catch(() => {});
  }, [orderId]);

  const reenviar = () => {
    setEnviando(true); setError(null);
    fetch(`${API_URL}/api/orders/${orderId}/recibo-whatsapp`, { method: 'POST', headers: jsonH(), body: JSON.stringify({ origen: 'pedidos' }) })
      .then(async (r) => ({ ok: r.ok, d: await r.json().catch(() => ({})) }))
      .then(({ ok, d }) => {
        if (!ok || !d.wa_url) { setError(d.error || 'No se pudo armar el WhatsApp'); return; }
        setEnvios(d.envios || []);
        window.open(d.wa_url, '_blank', 'noopener');
      })
      .catch(() => setError('No se pudo armar el WhatsApp'))
      .finally(() => setEnviando(false));
  };

  if (!orderId) return null;
  return (
    <div className="op-recibo-wa">
      <h4 className="op-insp-h">Comprobante por WhatsApp</h4>
      {waDisponible === true && (
        <Button size="sm" variant="primary" onClick={reenviar} disabled={enviando}>
          {enviando ? 'Armando…' : (envios.length ? 'Reenviar por WhatsApp' : 'Enviar por WhatsApp')}
        </Button>
      )}
      {waDisponible === false && (
        <p className="op-recibo-wa__sin-celular">Sin celular: no se puede enviar.</p>
      )}
      {error && <p className="op-recibo-wa__error">{error}</p>}
      {envios.length > 0 && (
        <ul className="op-recibo-wa__lista">
          {envios.map((e, i) => (
            <li key={`${e.enviadoEn}-${i}`}>
              Enviado el {fmtFechaCorta(e.enviadoEn)}{e.usuario ? ` por ${e.usuario}` : ''}{e.origen === 'pos' ? ' (al vender)' : ''}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
